<template>
    <div class="contentHome">
        <div class="centerPage">
            <el-breadcrumb separator-class="el-icon-arrow-right" class="breadCrumb">
                <el-breadcrumb-item>
                    <a href="javaScript:void(0);" class="aHref" @click="returnBack">{{back==1?'心理测试':'服务类型'}}</a>
                </el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/examDetail' ,query:{back:back,id: id}}">测试详情</el-breadcrumb-item>
                <el-breadcrumb-item>测试结果</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="question">
                <h3>测试结果</h3>
                <div class="result">
                    <p class="artHead">
                        <strong>测试得分：{{detail.score}}分</strong>
                        <strong>测试结果：{{resultAnalysis.title}}</strong>
                    </p>
                    <p class="suggest">{{resultAnalysis.scoreRangeMin}}-{{resultAnalysis.scoreRangeMax}}分</p>
                    <p class="judge">{{resultAnalysis.analysisDesc}}</p>
                </div>
                <div class="standard">
                    <strong>参考标准:</strong>
                    <p v-for="(item,index) in analyses" :key="index">
                        <span style="display: inline-block;width: 100px">{{item.scoreRangeMin}}-{{item.scoreRangeMax}}分</span>
                        <span>{{item.title}}</span>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import base from '@/api/common';

    export default {
        name: "psyDetail",
        data() {
            return {
                back: this.$route.query.back,
                id: this.$route.query.id,
                no: this.$route.query.no,
                detail: {
                    title: "测试",
                    score: 100,
                },
                suggest: "20~30分：你虽然有一定的抗挫折能力，但对某些较大的打击依然难与抗衡，须加强心理素质的锻炼。",
                judge: "在现实生活中,心理健康和生理健康是互相联系、互相作用的,心理健康每时每刻都在影响人的生理健康,只有生理和心理都处于健康的状态才是真正的健康。快来给自",
                resultAnalysis:{},
                analyses:[],
            }
        },
        mounted() {
            this.$ajax.post(base.api.exam.result.analysis.replace("{no}",this.no)).then((res)=>{
                if(res.data.status === 'success'){
                    this.detail = res.data.data;
                    if(res.data.data.analyses){
                        this.analyses = res.data.data.analyses;
                        let score = res.data.data.score;
                        $(res.data.data.analyses).each((i,o)=>{
                            if(o.scoreRangeMin <= score && score <= o.scoreRangeMax){
                                this.resultAnalysis = o;
                            }
                        })
                    }
                }
            });
        },
        methods: {
            returnBack() {
                if (this.back == 1) {
                    this.$router.push({name: 'exam'})
                } else if (this.back == 2) {
                    this.$router.push({name: 'serviceType'})
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/css/psychological.scss";

    h3 {
        border-bottom: 1px dashed #557BFF;
        width: 100%;
        text-align: center;
        padding-bottom: 13px;
    }
</style>